import request from "../utils/request";

export function getApiConfiguration(type: string) {
    return request.request({
        url: '/api/configuration/',
        method: 'get',
        params: {type}
    })
}

export function modifyApiConfiguration(type: string, data: any) {
    return request.request({
        url: '/api/configuration/',
        method: 'post',
        data: {type, details: data}
    })
}

export function getExternalApiConfiguration(system: string) {
    return request.request({
        url: '/external-interface/setting-info',
        method: 'get',
        params: {sysName: system}
    })
}


export function modifyExternalApiConfiguration(data: any) {
    return request.request({
        url: '/external-interface/setting-info',
        method: 'post',
        data: data
    })
}
